import React from 'react';
import { connect } from 'react-redux';
import { Sticky } from 'react-sticky';
import { Link, Element, animateScroll as scroll } from 'react-scroll';
import ArtifactViewMainContentTechnicalDetails from '~/artifact/containers/ArtifactViewMainContentTechnicalDetails';
import ArtifactViewMainContentLibraryInformation from '~/artifact/containers/ArtifactViewMainContentLibraryInformation';
import ArtifactViewMainContentReferences from '~/artifact/containers/ArtifactViewMainContentReferences';
import ArtifactViewMainContentExploits from '~/artifact/containers/ArtifactViewMainContentExploits';
import { vulnSectionsMap } from '~/constants/ModelConstants';
import GenericCallToAction from '~/containers/GenericViewPaywall/genericCTAWithNoEmailInput';
import Tooltip from '~/components/Tooltip';
type ArtifactViewMainContentProps = {
  artifactState: object;
  paywalledContent: any[];
};
class ArtifactViewMainContent extends React.Component<ArtifactViewMainContentProps, {}> {
  constructor(props) {
    super(props);
  }
  scrollToTop() {
    scroll.scrollToTop();
  }
  render() {
    const { artifactState, paywalledContent = [] } = this.props;
    const { artifact } = artifactState;
    const isTechnicalInfoPaywalled = paywalledContent.includes(
      vulnSectionsMap.VULNERABILITY_TECHNICAL_INFORMATION
    );
    const isExploitInformationPaywalled = paywalledContent.includes(
      vulnSectionsMap.EXPLOIT_INFORMATION
    );
    const isLibraryInformationPaywalled = paywalledContent.includes(
      vulnSectionsMap.LIBRARY_INFORMATION
    );
    const isReferencesPaywalled = paywalledContent.includes(vulnSectionsMap.REFERENCES);
    const paywallDisplay = (
      <div className="mb" title="paywall">
        <GenericCallToAction paywalledContent={paywalledContent} />
      </div>
    );
    // Reorder items in this list to change the order of display.
    const artifactSections = [
      !isTechnicalInfoPaywalled ? (
        <ArtifactViewMainContentTechnicalDetails
          title={vulnSectionsMap.VULNERABILITY_TECHNICAL_INFORMATION}
          artifact={artifact}
          key="technical-info-section"
        />
      ) : null,
      !isLibraryInformationPaywalled ? (
        <ArtifactViewMainContentLibraryInformation
          title={vulnSectionsMap.LIBRARY_INFORMATION}
          artifact={artifact}
          key="library-section"
          paywalledContent={paywalledContent}
        />
      ) : null,
      !isExploitInformationPaywalled ? (
        <ArtifactViewMainContentExploits
          title={vulnSectionsMap.EXPLOIT_INFORMATION}
          artifact={artifact}
          key="exploit-section"
        />
      ) : (
        <div title={vulnSectionsMap.EXPLOIT_INFORMATION} key="exploit-section">
          {paywallDisplay}
        </div>
      ),
      !isReferencesPaywalled ? (
        <ArtifactViewMainContentReferences
          title={vulnSectionsMap.REFERENCES}
          artifact={artifact}
          key="references-section"
        />
      ) : null,
    ];
    const premiumIconClassName = 'sci inline_block sci__crown color--premium';
    // Only show the non-null sections. A section is usually null when it is paywalled refer to artifactSections array above.
    const artifactSectionsHtml = artifactSections
      .filter(section => section !== null)
      .map((section, index) => {
        const { title } = section.props;
        const isPaywalled = paywalledContent.includes(title);
        return (
          <Element name={title} key={index}>
            <div className="pb">
              <h4 className="pb bo--1 bo-rad--3 border-color--white-dark font-family--gotham-bold bg-color--white-light font--16 text--bold color--black-light p text--">
                {title}
                {isPaywalled && (
                  <span className="inline-block ml---">
                    <Tooltip id="exploit-info-section" content="Premium feature">
                      <i className={`${premiumIconClassName} font--16`} />
                    </Tooltip>
                  </span>
                )}
              </h4>
              <div className="ph pt-">{section}</div>
            </div>
          </Element>
        );
      });
    const activeSectionClassName = 'bo-b--5 border-color--muted-dark bg-color--hover-muted-light';
    const tabCommonClassName =
      'text--bold hover--no-underline inline-block height--40 ph pt- bg-color--hover-primary bg-color--transition-300ms-ease-out';
    const linkContainerClassName = 'bo-r--1 border-color--white-dark inline-block';
    return (
      <section>
        <Sticky>
          {({ style, isSticky }) => (
            <div
              style={{ ...style, zIndex: 2 }}
              className="bo--1 bg-color--white-light border-color--white-dark bo-rad--3"
            >
              <div className="bo-b--5 border-color--white-dark">
                <div className={linkContainerClassName}>
                  <Link
                    activeClass={`${activeSectionClassName}`}
                    className={`${tabCommonClassName}`}
                    to={vulnSectionsMap.VULNERABILITY_TECHNICAL_INFORMATION}
                    spy={true}
                    smooth={true}
                    offset={-50}
                    duration={500}
                  >
                    {vulnSectionsMap.VULNERABILITY_TECHNICAL_INFORMATION}
                  </Link>
                </div>
                <div className={linkContainerClassName}>
                  <Link
                    activeClass={`${activeSectionClassName}`}
                    className={`${tabCommonClassName}`}
                    to={vulnSectionsMap.LIBRARY_INFORMATION}
                    spy={true}
                    smooth={true}
                    offset={-50}
                    duration={500}
                  >
                    {vulnSectionsMap.LIBRARY_INFORMATION}
                  </Link>
                </div>
                <div className={linkContainerClassName}>
                  <Link
                    activeClass={`${activeSectionClassName}`}
                    className={`${tabCommonClassName}`}
                    to={vulnSectionsMap.EXPLOIT_INFORMATION}
                    spy={true}
                    smooth={true}
                    offset={-50}
                    duration={500}
                  >
                    {vulnSectionsMap.EXPLOIT_INFORMATION}
                    {isExploitInformationPaywalled && (
                      <span className="inline-block ml---">
                        <Tooltip id="exploit-info-nav" content="Premium feature">
                          <i className={`${premiumIconClassName} font--12`} />
                        </Tooltip>
                      </span>
                    )}
                  </Link>
                </div>
                <div className={linkContainerClassName}>
                  <Link
                    activeClass={`${activeSectionClassName}`}
                    className={`${tabCommonClassName}`}
                    to={vulnSectionsMap.REFERENCES}
                    spy={true}
                    smooth={true}
                    offset={-50}
                    duration={500}
                  >
                    {vulnSectionsMap.REFERENCES}
                  </Link>
                </div>
                {isSticky && (
                  <a
                    onClick={this.scrollToTop}
                    className="pull--right text--uppercase color--black-light color--transition-300ms-ease-out font--11 text--bold hover--no-underline flex flex--align-items--center p- color-hover--primary"
                  >
                    <i className="fa fa-arrow-up font--11 mr--" /> Back to Top
                  </a>
                )}
              </div>
            </div>
          )}
        </Sticky>
        <div className="mt">{artifactSectionsHtml}</div>
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContent);
